export interface MenuDataItem {
  entity: string;
  label: string;
  link: string;
  externalLink?: string;
  children?: Array<MenuDataItem>;
}

export interface MenuData extends Array<MenuDataItem> {}

// My collection | Sales history  | Shop | Shirts & collections | Community

export const menuOptions: MenuData = [
  {
    entity: "menu-myCollection",
    label: "My Collection",
    link: "/my-profile",
  },
  {
    entity: "menu-shirts-collections",
    label: "Shirts",
    link: "/shirts-collections",
  },
  {
    entity: "menu-community",
    label: "Community",
    link: "/community",
  },
  {
    entity: "search-for-collectors",
    label: "Collectors",
    link: "/search-for-collectors",
  },
  {
    entity: "menu-store",
    label: "Shop",
    link: "/store",
  },
];
